var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3010,
    height: 385,
    viewBox: "0 0 3010 385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 42.969,
    y1: 320.89,
    x2: 529.5,
    y2: 320.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06683b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99cc3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 142.906,
    y1: 194.672,
    x2: 947.625,
    y2: 194.672,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 32.469,
    y1: 68.422,
    x2: 810.875,
    y2: 68.422,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STREAMFOG_logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "cls-1",
    d: "M1258.89,124.153l25.94-25.974s-16.59-25.974-64.85-25.974-83,23.744-83,67.532,31.73,56.706,57.07,67.532,64.84,13.334,64.84,41.558S1224.5,280,1217.39,280c-33.68,0-46.69-23.377-46.69-23.377l-33.72,10.39s12.55,51.948,80.41,51.948c21.65,0,47.1-6.431,64.04-24.973C1289.67,284.963,1300,268.1,1300,249c0-33.784-29.53-54.4-52-62-41.11-13.915-69.45-27.64-72.11-47.263-0.77-5.64,1.36-11.452,4.31-16,9.04-13.94,29.98-15.17,39.78-15.17C1249.56,108.568,1258.89,124.153,1258.89,124.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "cls-1",
    d: "M1320.21,75.013h141.11v38.461h-51.31V316.033h-38.48V113.474h-51.32V75.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-1",
    d: "M1492,75h98.12a71.725,71.725,0,0,1,61.97,72.383,73.635,73.635,0,0,1-18.08,46.532,75.211,75.211,0,0,1-23.23,18.1Q1637.885,265,1665,318h-43.9l-49.06-100.819h-41.31V318H1492V75Zm38.73,38.777V178.4h56.81s25.82-1.866,25.82-31.021c0-34.106-28.4-33.606-28.4-33.606h-54.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "cls-1",
    d: "M1688,76h126v38.617h-87.43V176.4h66.86V217.6h-66.86v61.787H1814V318H1688V76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "cls-1",
    d: "M1830,318L1984.62,76H2031V318h-38.65V261.362h-79.89Q1894.43,289.68,1876.38,318H1830Zm162.35-95.255V137.787l-54.12,84.958h54.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-1",
    d: "M2075,318.141h38.62V173.887l61.79,144.254h43.77l64.37-146.83v146.83h38.62V76h-38.62q-42.5,95.312-84.97,190.622h-2.57Q2154.82,171.311,2113.62,76H2075V318.141Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "cls-1",
    d: "M2367,318.3h38.64V217.77h66.99V176.528h-66.99V114.665h85.02V76H2367V318.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-1",
    d: "M2632,319c-67.38,0-122-55.293-122-123.5S2564.62,72,2632,72s122,55.293,122,123.5S2699.38,319,2632,319Zm83.47-126.073c-1.73-43.355-37.81-79.88-82.09-80.579-45.7-.723-84.37,36.966-84.85,83.152-0.49,45.9,36.9,84.206,82.19,84.906C2678.45,281.145,2717.35,239.843,2715.47,192.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    className: "cls-1",
    d: "M2959.72,175.141h-79.53v38.536h38.48V277.9c-28.64,5.867-58.95-1.94-79.53-23.122-16.75-17.235-23.17-39.711-23.09-59.089,0.12-29.923,15.79-58.31,38.48-71.934,32.67-19.612,79.53-5.138,79.53-5.138l12.83-33.4s-17.45-13.022-51.31-12.846c-29.26.152-56.43,12.91-76.97,30.829-25.14,21.942-42.87,55.181-43.61,92.487a121.018,121.018,0,0,0,18.07,66.628c24.38,38.817,68.91,56.689,105.08,56.689,35.61,0,61.57-15.415,61.57-15.415V175.141Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line_3",
    className: "cls-2",
    d: "M67.959,295.915H504.51a24.983,24.983,0,1,1,0,49.966H67.959A24.983,24.983,0,1,1,67.959,295.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line_2",
    className: "cls-3",
    d: "M167.893,169.683H922.652a24.984,24.984,0,1,1,0,49.967H167.893A24.984,24.984,0,1,1,167.893,169.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "line_1",
    className: "cls-4",
    d: "M57.44,43.452H785.9a24.983,24.983,0,1,1,0,49.967H57.44A24.983,24.983,0,0,1,57.44,43.452Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.2615801080f9fc2e1e53f1b3266a069f.svg";
export { ForwardRef as ReactComponent };